import React from "react";

import PropTypes from "prop-types";

import wordSplittingRegEx from "@/view/utils/wordSplittingRegEx";

const propTypes = {
  startOffsetRelativeToParent: PropTypes.number,
  text: PropTypes.string,
};

const ReadAloudSpans = ({ startOffsetRelativeToParent, text }) => {
  const textWords = text?.split(wordSplittingRegEx);

  let currentOffset = startOffsetRelativeToParent;

  return textWords?.map((word, i) => {
    if (!word) return null;

    // We only want the word itself to be highlighted, not any characters before or after it (e.g. white space).
    const charactersBeforeWord = word.match(/^\W+/)?.[0];
    const charactersAfterWord = word.match(/\W+$/)?.[0];
    const trimmedWord = word
      .replace(charactersBeforeWord, "")
      .replace(charactersAfterWord, "");

    const startingCharacterIndex =
      currentOffset + (charactersBeforeWord?.length || 0);

    currentOffset += word.length;

    if (!trimmedWord) return word;

    return (
      <React.Fragment key={`${word}-${startingCharacterIndex}-${i}`}>
        {charactersBeforeWord}
        {trimmedWord ? (
          <span data-starting-character-index={startingCharacterIndex}>
            {trimmedWord}
          </span>
        ) : null}
        {charactersAfterWord}
      </React.Fragment>
    );
  });
};

ReadAloudSpans.propTypes = propTypes;

export default ReadAloudSpans;
